import React, { useState } from "react";
import { ContentPasteSearch } from "@mui/icons-material";
import { get_new_guideline_icon_count } from "../../api/Users";

export default function ViewAllGuidelines({ totalItems }) {
  const [newGuideline, ShowNewGuideline] = useState(true);
  const [newCount, setNewCount] = useState(0);

  get_new_guideline_icon_count()
    .then((response) => {
      if (response.status == "success") {
        ShowNewGuideline(true);
        setNewCount(response.data.result[0].unseen_notices_count);
      }
    })
    .catch((error) => {
      console.error("Error fetching new notices:", error);
    });

  return (
    <div>
      {newGuideline ? (
        <div
          className="notification"
          animate={
            totalItems ? { x: [-5, 5, -5, 5, 0], rotate: [0, 5, -5, 5, 0] } : ""
          }
        >
          <button class="btn position-relative cart p-2 pt-1 pb-1">
            <ContentPasteSearch />
            {newCount > 0 && (
              <span
                class="position-absolute translate-middle badge rounded-pill bg-danger text-light border border-2"
                style={{ marginLeft: "150px", marginTop: "5px" }}
              >
                {newCount}
              </span>
            )}
          </button>
        </div>
      ) : (
        <ContentPasteSearch />
      )}
    </div>
  );
}
